import { getStoredToken } from './authStorage';

const FALLBACK_API_ORIGIN = 'http://127.0.0.1:8000';

export function getApiBaseUrl(): string {
    const rawBase = (import.meta.env.VITE_API_BASE || FALLBACK_API_ORIGIN).trim().replace(/\/+$/, '');
    return rawBase.endsWith('/api') ? rawBase : `${rawBase}/api`;
}

export function buildApiUrl(path: string): string {
    return `${getApiBaseUrl()}/${path.replace(/^\/+/, '')}`;
}

export function getAuthHeaders(headers: HeadersInit = {}): HeadersInit {
    const token = getStoredToken();

    return {
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...headers,
    };
}
